import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-auth-layout-header',
  templateUrl: './auth-layout-header.component.html',
  styleUrls: ['./auth-layout-header.component.scss']
})
export class AuthLayoutHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
